import { render } from "./CookiesTable.vue?vue&type=template&id=70ce7816&scoped=true&ts=true"
import script from "./CookiesTable.vue?vue&type=script&lang=ts"
export * from "./CookiesTable.vue?vue&type=script&lang=ts"

import "./CookiesTable.vue?vue&type=style&index=0&id=70ce7816&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ce7816"]])

export default __exports__